export function AuthHeaders() {
  return (
    <div className="flex flex-col gap-4">
      <div className="my-2 flex max-w-md flex-col">
        <div
          className="flex flex-col gap-4"
          data-testid="field-X-Auth-Uuid-undefined"
        >
          <div className="flex flex-row items-center">
            <div className="flex items-center gap-2 text-nowrap">
              <code className="font-bold">X-Auth-Uuid</code>
              <code className="text-ellipsis text-inpay-black-primary-600"></code>
              <span className="required">required</span>
            </div>
          </div>
          <div className="flex flex-row">
            <div className="custom-rendering undefined">
              Universally unique identifier sent by Inpay
            </div>
          </div>
        </div>
      </div>
      <div className="my-2 flex max-w-md flex-col">
        <div
          className="flex flex-col gap-4"
          data-testid="field-Authorization-undefined"
        >
          <div className="flex flex-row items-center">
            <div className="flex items-center gap-2 text-nowrap">
              <code className="font-bold">Authorization</code>
              <code className="text-ellipsis text-inpay-black-primary-600"></code>
              <span className="required">required</span>
            </div>
          </div>
          <div className="flex flex-row">
            <div className="custom-rendering undefined">
              Bearer [bearer token sent by Inpay]
            </div>
          </div>
        </div>
      </div>
      <div className="my-2 flex max-w-md flex-col">
        <div
          className="flex flex-col gap-4"
          data-testid="field-X-Request-ID-undefined"
        >
          <div className="flex flex-row items-center">
            <div className="flex items-center gap-2 text-nowrap">
              <code className="font-bold">X-Request-ID</code>
              <code className="text-ellipsis text-inpay-black-primary-600"></code>
              <span className="required">required</span>
            </div>
          </div>
          <div className="flex flex-row">
            <div className="custom-rendering undefined">
              Universally unique identifier sent by the Customer
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
